import React, { useEffect, useState } from 'react';
import { Button, Col, Modal, Form, Table, Image } from 'react-bootstrap';
import { Toggle } from '../../../../../../../superAdminComponents/superAdminReusable/reusableSuperAdminButton/Toggle';

function ItemSetup({ formik, menu }) {
  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const [showItemModal, setShowItemModal] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedItems, setSelectedItems] = useState({});
  const [currentCategoryId, setCurrentCategoryId] = useState(null);

  // Toggle modal for category selection
  const handleCategoryModalShow = () => setShowCategoryModal(true);
  const handleCategoryModalClose = () => setShowCategoryModal(false);

  useEffect(() => {
    if (formik.values.comboItems?.length) {
      const categories = formik.values.comboItems.map(
        (item) => item.category_id
      );
      setSelectedCategories(categories);

      const items = formik.values.comboItems.reduce((acc, combo) => {
        acc[combo.category_id] = combo.items;
        return acc;
      }, {});
      setSelectedItems(items);
    }
  }, []); // Depend on comboItems to ensure updates reflect properly

  // Toggle modal for item selection
  const handleItemModalShow = (categoryId) => {
    setCurrentCategoryId(categoryId);
    setShowItemModal(true);
  };
  const handleItemModalClose = () => setShowItemModal(false);

  // Handle category selection
  const handleCategorySelect = (categoryId) => {
    setSelectedCategories((prevSelected) =>
      prevSelected.includes(categoryId)
        ? prevSelected.filter((id) => id !== categoryId)
        : [...prevSelected, categoryId]
    );
  };

  // Handle item selection
  const handleItemSelect = (item) => {
    setSelectedItems((prevItems) => {
      const itemsForCategory = prevItems[currentCategoryId] || [];
      if (itemsForCategory.some((i) => i._id === item._id)) {
        // Remove item if already selected
        const updatedItemsForCategory = itemsForCategory.filter(
          (i) => i._id !== item._id
        );
        updateFormikItems(currentCategoryId, updatedItemsForCategory);
        return {
          ...prevItems,
          [currentCategoryId]: updatedItemsForCategory,
        };
      }

      // Add new item
      const updatedItemsForCategory = [
        ...itemsForCategory,
        { ...item, additionalPrice: 0 },
      ];
      updateFormikItems(currentCategoryId, updatedItemsForCategory);

      return {
        ...prevItems,
        [currentCategoryId]: updatedItemsForCategory,
      };
    });
  };

  // Helper function to update formik.values.items
  const updateFormikItems = (categoryId, itemsForCategory) => {
    const updatedItems = selectedCategories.map((catId) => ({
      category_id: catId,
      items:
        catId === categoryId ? itemsForCategory : selectedItems[catId] || [],
    }));

    formik.setFieldValue('comboItems', updatedItems);
  };

  // Set default item
  const setDefaultItem = (categoryId, itemId) => {
    setSelectedItems((prevItems) => {
      const updatedItemsForCategory = prevItems[categoryId].map((item) =>
        item._id === itemId
          ? { ...item, default: true }
          : { ...item, default: false }
      );
      updateFormikItems(categoryId, updatedItemsForCategory);
      return {
        ...prevItems,
        [categoryId]: updatedItemsForCategory,
      };
    });
  };

  // Delete item from category
  const deleteItem = (categoryId, itemId) => {
    setSelectedItems((prevItems) => {
      const updatedItemsForCategory = prevItems[categoryId].filter(
        (item) => item._id !== itemId
      );
      updateFormikItems(categoryId, updatedItemsForCategory);
      return {
        ...prevItems,
        [categoryId]: updatedItemsForCategory,
      };
    });
  };

  // Update additional price
  const updateAdditionalPrice = (categoryId, itemId, price) => {
    setSelectedItems((prevItems) => {
      const updatedItemsForCategory = prevItems[categoryId].map((item) =>
        item._id === itemId ? { ...item, additionalPrice: price } : item
      );
      updateFormikItems(categoryId, updatedItemsForCategory);
      return {
        ...prevItems,
        [categoryId]: updatedItemsForCategory,
      };
    });
  };

  // Delete entire category section
  const deleteCategory = (categoryId) => {
    setSelectedCategories((prevCategories) =>
      prevCategories.filter((id) => id !== categoryId)
    );
    setSelectedItems((prevItems) => {
      const updatedItems = { ...prevItems };
      delete updatedItems[categoryId];
      updateFormikItems(categoryId, []);
      return updatedItems;
    });
  };

  console.log(formik.values);

  return (
    <>
      <div>
        <div className="d-flex justify-content-between">
          <div className="f16-700">Assign Categories and items to the Menu</div>
          <div>
            <Button variant="danger" onClick={handleCategoryModalShow}>
              Add Category
            </Button>
          </div>
        </div>
        <div className="my-2 d-flex justify-content-evenly">
          <div className="f16-500">Substitutable Combo</div>

          <Col md={6} xs={6}>
            <div className="d-flex align-items-center">
              <div className="f12-400 mr-2">No</div>
              <Toggle
                checked={formik.values.substitutable}
                toggleFunction={() =>
                  formik.setFieldValue(
                    'substitutable',
                    !formik.values.substitutable
                  )
                }
              />
              <div className="f12-400 ml-2">Yes</div>
            </div>
          </Col>
        </div>

        {/* Render category sections based on selected categories */}
        {selectedCategories.map((categoryId) => {
          const category = menu.find((cat) => cat._id === categoryId);
          return (
            <div key={categoryId} className="my-4 p-3  bg-light">
              <div
                className="d-flex justify-content-between align-items-center pr-3"
                style={{
                  backgroundColor: '#bdbdbd',
                  borderRadius: '8px',
                }}
              >
                <div className="d-flex align-items-center px-1">
                  <h5>{category?.name}</h5>

                  <Image
                    src={require('../../../../../../../../assets/images/UserManagement/Delete.svg')}
                    alt="Delete"
                    title="Delete"
                    fluid
                    onClick={() => deleteCategory(categoryId)}
                    className="mx-4"
                  />
                </div>
                <div
                  className="f14-500 p-1 ml-3"
                  style={{
                    border: '1px solid #ee3a23',
                    borderRadius: '4px',
                    backgroundColor: '#ffc0c05e',
                  }}
                  onClick={() => handleItemModalShow(categoryId)}
                >
                  + Add Item
                </div>
              </div>

              {/* Display selected items in table format under each category */}
              <Table striped hover className="mt-3">
                <thead>
                  <tr>
                    <th>Set Default</th>
                    <th>Item Name</th>
                    <th>Item Price</th>
                    <th>Units</th>
                    <th>Measure</th>
                    <th>Additional Price</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedItems[categoryId]?.map((item) => (
                    <tr key={item._id}>
                      <td>
                        <Form.Check
                          type="radio"
                          name={`defaultItem-${categoryId}`}
                          checked={item?.default || false}
                          onChange={() => setDefaultItem(categoryId, item?._id)}
                        />
                      </td>
                      <td>{item?.name}</td>
                      <td>{item?.size?.[0]?.price || ''}</td>
                      <td> 1 </td>
                      <td> KG </td>
                      <td width={'20%'}>
                        <Form.Control
                          type="number"
                          value={item?.additionalPrice}
                          onChange={(e) =>
                            updateAdditionalPrice(
                              categoryId,
                              item?._id,
                              e.target.value
                            )
                          }
                        />
                      </td>
                      <td>
                        <Button
                          variant="danger"
                          size="sm"
                          onClick={() => deleteItem(categoryId, item?._id)}
                        >
                          Delete
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          );
        })}
      </div>

      {/* Modal for Adding Categories */}
      <Modal show={showCategoryModal} onHide={handleCategoryModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Select Categories</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ maxHeight: '200px', overflowY: 'scroll' }}>
            {menu.map((category) => (
              <div
                key={category._id}
                className="d-flex align-items-center mb-2"
              >
                <input
                  type="checkbox"
                  style={{ width: '20px', height: '20px' }}
                  checked={selectedCategories.includes(category._id)}
                  onChange={() => handleCategorySelect(category._id)}
                />
                <span className="ml-2">{category.name}</span>
              </div>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-light" onClick={handleCategoryModalClose}>
            cancel
          </Button>
          <Button variant="danger" onClick={handleCategoryModalClose}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal for Adding Items from Specific Category */}
      <Modal show={showItemModal} onHide={handleItemModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Select Items</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ maxHeight: '240px', overflowY: 'scroll' }}>
            {/* Show items only from the currently selected category */}
            {currentCategoryId &&
              menu
                .find((cat) => cat._id === currentCategoryId)
                .items.map((item) => (
                  <div
                    key={item._id}
                    className="d-flex align-items-center mb-2"
                  >
                    <input
                      type="checkbox"
                      style={{ width: '20px', height: '20px' }}
                      checked={selectedItems[currentCategoryId]?.some(
                        (i) => i._id === item._id
                      )}
                      onChange={() => handleItemSelect(item)}
                    />
                    <span className="ml-2">{item.name}</span>
                  </div>
                ))}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleItemModalClose}>
            Close
          </Button>
          <Button variant="danger" onClick={handleItemModalClose}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ItemSetup;
